import React, { useEffect } from 'react';
import { X } from 'lucide-react';

export default function BottomSheet({ open, onClose, title, children, footer }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center">
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
        aria-hidden
      />
      <div
        className="relative w-full max-w-md md:max-w-2xl lg:max-w-3xl bg-white rounded-t-3xl shadow-2xl animate-[slideUp_.2s_ease-out] flex flex-col"
        style={{
          // Leave a bit of viewport above the sheet (for context + tap-to-dismiss)
          // and respect the device safe area at the bottom so the last action
          // never sits under a home bar or system gesture zone.
          maxHeight: 'min(92dvh, calc(100vh - 4rem))',
          paddingBottom: 'env(safe-area-inset-bottom)',
        }}
      >
        <div className="flex items-center justify-between px-5 pt-4 pb-2 shrink-0">
          <div className="text-lg font-semibold text-garden-ink">{title}</div>
          <button
            onClick={onClose}
            className="min-h-11 min-w-11 -mr-2 rounded-full flex items-center justify-center text-garden-muted hover:bg-black/5"
            aria-label="Close"
          >
            <X size={22} />
          </button>
        </div>
        <div className="px-5 pb-6 overflow-y-auto flex-1">{children}</div>
        {footer ? <div className="px-5 py-3 border-t border-black/5 shrink-0">{footer}</div> : null}
      </div>
      <style>{`@keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }`}</style>
    </div>
  );
}
